import { render, staticRenderFns } from "./LabResults.vue?vue&type=template&id=229899c4&"
import script from "./LabResults.vue?vue&type=script&lang=js&"
export * from "./LabResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports